import { useEffect, useState } from 'react';
import { fetchPosts } from '../../utils/blogUtils';
import { PostSlider } from '../../components/blog';
import blog_hero from "../../images/blog_hero_background.jpg"

const Blog = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPosts().then((data) => {
      setPosts(data);
      setLoading(false);
    });
  }, []);

  if (loading) return <div>Cargando blogs...</div>;

  return (
    <div className='mb-5 pb-5 d-flex flex-column gap-5' id="blog">
      <div className='img-fluid mb-5' style={{
        backgroundImage: `url(${blog_hero})`,
        position: "relative",
        paddingTop: "5em",
        paddingBottom: "5em",
        backgroundPosition: "center",
        backgroundSize: "cover"
      }}>
        <div className='container'>
          <h1 className='beba-font p-0 m-0'>
            <span className='title-blue'>Descubre</span><br/> como lo<br/> <span className='title-red'>logramos</span>
          </h1>
        </div>
      </div>
      <div className='container my-5 '>
        <PostSlider posts={posts} description />
      </div>
    </div>
  );
};

export default Blog; 